import { observable, computed, action, runInAction, makeObservable } from "mobx";
import { ServiceOperationDetails, ServiceDetail } from './ServiceVehicleModel';
import { ApiBasePath } from "../../../utils/ApiBasePath";
import * as Request from "superagent";

export default class OperationDetailsModel {
  @observable response: ServiceOperationDetails;
  @observable isDetailsExist: boolean = false;
  @observable isFetching: boolean = false;
  @observable isRequestError: boolean = false;
  resetDetails: () => void;

  constructor(resetDetails) {
    makeObservable(this);
    this.resetDetails = resetDetails;
  }
  
  @action setDetailsExist = (status: boolean) =>  {
      this.isDetailsExist = status;
  }

  @computed get performance() : ServiceDetail[]  {
    if (this.response){
      return this.response.performanceInvoiceLines.map<ServiceDetail>((item) => {
        return (
          {
            itemPosition: item.position,
            itemDescription: item.desc,
            itemId: item.id
          }
        );
      });
    }
  }

  @computed get safety() : ServiceDetail[]  {
    if (this.response) {
      return this.response.safetyInvoiceLines.map<ServiceDetail>((item) => {
        return (
          {
            itemPosition: item.position,
            itemDescription: item.desc,
            itemId: item.id
          }
        );
      });
    }
  }

  get retainedValue() : ServiceDetail[]  {
    return [{
      itemPosition: '0',
      itemDescription: 'By having an authorised Subaru Service Centre carry out the standard scheduled service, \
        as per the manufacturer’s recommendations, you will have the reassurance of a full Subaru service history \
        to further help safeguard the ongoing value of your investment.',
      itemId: '166160'
    }];
  }

  @computed get standardQuote() : string {
    return this.response ? this.response.totalPrice : '';
  }

  @action reset = () => {
    this.response = null;
    this.isDetailsExist = false;
    this.isFetching = false;
  }

  @action fetchVehicleServiceDetails = (vin: string, groupVarId: string) => {
    this.isFetching = true;
    let url = `${ApiBasePath.infomedia}/vehicle/${vin}/service-operation-details/${groupVarId}`;
    Request.get(url).then(
      response => {
        runInAction(() => {
          this.response = response.body;
          this.isFetching = false;
          this.isDetailsExist = true;
          this.isRequestError = false;
        });
      },
      error => {
        runInAction(() => {
          console.log(`An error occurred loading your vehicle service operation details: ${error}`);
          this.resetDetails();
          this.isRequestError = true;
        });
      }
    );
  };  
}